export default __webpack_public_path__ + "img/logox1000px.efac2236.efac2236.png";